<nav class="navbar navbar-light bg-light">
  <a class="navbar-brand" href="#"><b>UNO.DENNISGUNIA.DE</b> - Version 1.0</a>
</nav>

  <router-outlet #outlet="outlet"></router-outlet>


